(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["retrolab-game-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retrolab-game-search')) {
    const catalogs = new Map();
    const loadCatalog = sources => {
      const key = JSON.stringify(sources);
      if (!catalogs.has(key)) {
        const urls = [...sources.twenty, ...sources.sixty];
        const promise = Promise.all(urls.map(async url => {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Catalogue request failed');
          const chunk = await response.json();
          if (!Array.isArray(chunk) || chunk.some(title => typeof title !== 'string')) throw new Error('Invalid catalogue');
          return chunk;
        })).then(chunks => {
          const twenty = chunks.slice(0, sources.twenty.length).flat();
          const sixty = chunks.slice(sources.twenty.length).flat();
          const inTwenty = new Set(twenty.map(title => title.toLowerCase()));
          const combined = new Map();
          sixty.forEach(title => combined.set(title.toLowerCase(), title));
          twenty.forEach(title => combined.set(title.toLowerCase(), title));
          return [...combined.values()].map(title => ({ title, search: title.toLowerCase(), twenty: inTwenty.has(title.toLowerCase()) })).sort((a, b) => a.search.localeCompare(b.search));
        }).catch(error => { catalogs.delete(key); throw error; });
        catalogs.set(key, promise);
      }
      return catalogs.get(key);
    };
    customElements.define('retrolab-game-search', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.input = this.querySelector('.ai-game-search-input');
        this.clearBtn = this.querySelector('.ai-game-search-clear');
        this.resultsContainer = this.querySelector('.ai-game-search-results');
        this.tbody = this.querySelector('.ai-game-search-tbody');
        this.loadingDisplay = this.querySelector('.ai-game-search-loading');
        this.errorDisplay = this.querySelector('.ai-game-search-error');
        this.announcement = this.querySelector('.ai-game-search-announcement');
        this.viewMoreContainer = this.querySelector('.ai-game-search-view-more');
        this.viewMoreBtn = this.querySelector('.ai-game-search-view-more-btn');
        this.sources = JSON.parse(this.querySelector('[data-game-sources]').textContent);
        this.version = (this.version || 0) + 1;
        this.pageSize = 100;
        this.input.addEventListener('focus', () => this.ensureCatalog(), { signal });
        this.input.addEventListener('input', () => {
          this.version++;
          clearTimeout(this.searchTimeout);
          const query = this.input.value.trim();
          this.setClearState(Boolean(query));
          if (!query) { this.hideResults(); return; }
          this.searchTimeout = setTimeout(() => this.performSearch(query), 300);
        }, { signal });
        this.input.addEventListener('keydown', event => {
          if (event.key === 'Enter') { event.preventDefault(); clearTimeout(this.searchTimeout); this.performSearch(this.input.value.trim()); }
          if (event.key === 'Escape') {
            const dialog = this.closest('dialog[open]');
            event.preventDefault();
            event.stopPropagation();
            if (dialog) dialog.close();
            else this.clear();
          }
        }, { signal });
        this.clearBtn.addEventListener('click', () => this.clear(), { signal });
        this.viewMoreBtn.addEventListener('click', () => this.displayMoreResults(), { signal });
      }
      setClearState(active) {
        this.clearBtn.classList.toggle('active', active);
        this.clearBtn.tabIndex = active ? 0 : -1;
      }
      async ensureCatalog() {
        if (this.catalog) return this.catalog;
        if (this.loading) return this.loading;
        this.setAttribute('aria-busy', 'true');
        this.loadingDisplay.classList.add('active');
        this.errorDisplay.hidden = true;
        this.loading = loadCatalog(this.sources).then(catalog => {
          this.catalog = catalog;
          return catalog;
        }).catch(() => {
          if (this.isConnected) {
            this.errorDisplay.hidden = false;
            this.resultsContainer.classList.remove('active');
          }
          return null;
        }).finally(() => {
          this.loading = null;
          if (this.isConnected) {
            this.loadingDisplay.classList.remove('active');
            this.removeAttribute('aria-busy');
          }
        });
        return this.loading;
      }
      async performSearch(query) {
        const version = ++this.version;
        this.setClearState(Boolean(query));
        if (!query) { this.hideResults(); return; }
        this.resultsContainer.classList.remove('active');
        const catalog = await this.ensureCatalog();
        if (!catalog || !this.isConnected || version !== this.version) return;
        const lowerQuery = query.toLowerCase();
        this.filteredGames = catalog.filter(game => game.search.includes(lowerQuery));
        this.currentPage = 0;
        this.tbody.replaceChildren();
        if (this.filteredGames.length === 0) {
          const row = document.createElement('tr');
          const cell = document.createElement('td');
          cell.colSpan = 3;
          cell.className = 'ai-game-search-no-results';
          ['No results found, please try rewording your search.', '\u00a0', "If the game you are looking for isn't pre-installed please simply buy the 60,000+ Games Version that has the ability for you to install any game you want."].forEach(text => {
            const paragraph = document.createElement('p');
            paragraph.textContent = text;
            cell.append(paragraph);
          });
          row.append(cell);
          this.tbody.append(row);
          this.viewMoreContainer.classList.remove('active');
          this.announcement.textContent = 'No results found, please try rewording your search.';
        } else this.displayMoreResults();
        this.resultsContainer.classList.add('active');
      }
      displayMoreResults() {
        if (!this.filteredGames?.length) return;
        const start = this.currentPage * this.pageSize;
        const end = Math.min(start + this.pageSize, this.filteredGames.length);
        const fragment = document.createDocumentFragment();
        this.filteredGames.slice(start, end).forEach(game => {
          const row = document.createElement('tr');
          const title = document.createElement('td');
          title.textContent = game.title;
          row.append(title);
          [game.twenty, true].forEach(included => {
            const cell = document.createElement('td');
            cell.setAttribute('aria-label', included ? 'Included' : 'Not included');
            if (included) {
              const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
              svg.setAttribute('class', 'ai-game-search-checkmark');
              svg.setAttribute('viewBox', '0 0 24 24');
              svg.setAttribute('fill', 'none');
              svg.setAttribute('stroke', 'currentColor');
              svg.setAttribute('stroke-width', '3');
              svg.setAttribute('stroke-linecap', 'round');
              svg.setAttribute('stroke-linejoin', 'round');
              svg.setAttribute('aria-hidden', 'true');
              svg.setAttribute('focusable', 'false');
              const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
              polyline.setAttribute('points', '20 6 9 17 4 12');
              svg.append(polyline);
              cell.append(svg);
            }
            row.append(cell);
          });
          fragment.append(row);
        });
        this.tbody.append(fragment);
        this.currentPage++;
        this.viewMoreContainer.classList.toggle('active', end < this.filteredGames.length);
        this.announcement.textContent = `${this.filteredGames.length.toLocaleString()} matching games. Showing ${end.toLocaleString()}.`;
      }
      hideResults() {
        this.version++;
        this.resultsContainer.classList.remove('active');
        this.viewMoreContainer.classList.remove('active');
        this.tbody.replaceChildren();
        this.filteredGames = [];
        this.currentPage = 0;
        this.announcement.textContent = '';
      }
      clear() {
        clearTimeout(this.searchTimeout);
        this.input.value = '';
        this.setClearState(false);
        this.hideResults();
        this.input.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.version++;
        clearTimeout(this.searchTimeout);
        this.controller?.abort();
        this.controller = null;
      }
    });
    const preparedDialogs = new WeakSet();
    const focusSearch = search => {
      let delay = 0;
      const opened = new Set();
      const openDetails = (details, wrapper) => {
        if (!details || details.open || opened.has(details)) return;
        opened.add(details);
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.click();
        else details.open = true;
        const duration = getComputedStyle(wrapper || details).getPropertyValue('--animation-duration').trim();
        const milliseconds = duration ? parseFloat(duration) * (duration.endsWith('ms') ? 1 : 1000) : 400;
        delay = Math.max(delay, (Number.isFinite(milliseconds) ? milliseconds : 400) + 80);
      };
      let ancestor = search.parentElement;
      while (ancestor) {
        if (ancestor.classList.contains('accordion')) openDetails(ancestor.querySelector(':scope > details'), ancestor);
        if (ancestor.tagName === 'DETAILS') openDetails(ancestor, ancestor);
        ancestor = ancestor.parentElement;
      }
      setTimeout(() => {
        if (!search.isConnected) return;
        search.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        search.querySelector('input[type="search"]')?.focus({ preventScroll: true });
      }, delay);
    };
    document.addEventListener('click', event => {
      const close = event.target.closest('[data-game-dialog-close]');
      if (close) { close.closest('dialog')?.close(); return; }
      if (event.defaultPrevented || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download')) return;
      let url;
      try { url = new URL(link.href, location.href); } catch { return; }
      if (url.origin !== location.origin) return;
      const gamePage = /^\/pages\/games?-list\/?$/.test(url.pathname);
      const gameAnchor = url.pathname === location.pathname && url.search === location.search && url.hash === '#retrolab-game-search';
      if (!gamePage && !gameAnchor) return;
      const dialog = document.querySelector('[data-game-search-dialog]');
      const fromMenu = Boolean(link.closest('header-drawer, .header-wrapper, .header'));
      const inline = fromMenu && dialog ? null : document.getElementById('retrolab-game-search') || [...document.querySelectorAll('retrolab-game-search,game-search-table')].find(search => !search.closest('dialog'));
      if (!inline && !dialog) return;
      event.preventDefault();
      const drawer = link.closest('header-drawer');
      const restoreFocus = drawer?.querySelector(':scope > details > summary') || link;
      if (drawer) {
        const closeMenu = drawer.querySelector('.menu-drawer__close-menu-btn');
        if (closeMenu) closeMenu.click();
        else drawer.querySelector(':scope > details[open] > summary')?.click();
      }
      setTimeout(() => {
        if (inline?.isConnected) { focusSearch(inline); return; }
        if (!dialog?.isConnected) return;
        if (!preparedDialogs.has(dialog)) {
          dialog.addEventListener('close', () => {
            if (dialog.returnFocus?.isConnected) dialog.returnFocus.focus({ preventScroll: true });
          });
          dialog.addEventListener('click', click => {
            if (click.target !== dialog) return;
            const box = dialog.getBoundingClientRect();
            if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
          });
          preparedDialogs.add(dialog);
        }
        dialog.returnFocus = restoreFocus;
        if (!dialog.open) dialog.showModal();
        dialog.querySelector('input[type="search"]')?.focus({ preventScroll: true });
      }, drawer ? 400 : 0);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["retrolab-order-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('retrolab-order-summary')) {
    customElements.define('retrolab-order-summary', class extends HTMLElement {
      connectedCallback() {
        this.quantityOutput = this.querySelector('[data-retrolab-summary-quantity]');
        this.priceOutput = this.querySelector('[data-retrolab-summary-price]');
        this.consolesOutput = this.querySelector('[data-retrolab-summary-consoles]');
        this.sourceId = `quantity-breaks-${this.dataset.section}`;
        this.productRoot = this.closest('product-info') || this.closest('.product__info-container') || this.closest('.shopify-section');
        if (!this.productRoot || !this.quantityOutput || !this.priceOutput || !this.consolesOutput) return;
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            if (this.isConnected) this.updateSummary();
          });
        };
        this.sourceObserver = new MutationObserver(this.queueUpdate);
        this.structureObserver = new MutationObserver(() => {
          if (this.findSource() !== this.source) this.bindSource();
        });
        this.structureObserver.observe(this.productRoot, { childList: true, subtree: true });
        this.bindSource();
      }

      disconnectedCallback() {
        this.sourceObserver?.disconnect();
        this.structureObserver?.disconnect();
        this.source?.removeEventListener('change', this.queueUpdate);
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.source = null;
      }

      findSource() {
        const source = document.getElementById(this.sourceId);
        return source && this.productRoot.contains(source) && source.classList.contains('retrolab-quantity-breaks') ? source : null;
      }

      bindSource() {
        this.sourceObserver.disconnect();
        this.source?.removeEventListener('change', this.queueUpdate);
        this.source = this.findSource();
        if (this.source) {
          this.source.addEventListener('change', this.queueUpdate);
          this.sourceObserver.observe(this.source, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['checked', 'selected', 'data-selected-id']
          });
        }
        this.queueUpdate();
      }

      updateSummary() {
        const input = this.source?.querySelector('input[name="quantity"]:checked');
        const card = input?.nextElementSibling;
        const price = card?.matches('.quantity-break') ? card.querySelector('.quantity-break__price')?.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!input || !price) {
          this.hidden = true;
          this.signature = null;
          return;
        }
        const quantity = input.value === '1' ? this.dataset.singleQuantityLabel : this.dataset.quantityLabel.replace('[quantity]', input.value);
        const consoles = Array.from(card.querySelectorAll('.quantity-break__selector-item'), (row, index) => {
          const choices = Array.from(row.querySelectorAll('.quantity-break__variant-select'), select => select.selectedOptions[0]?.textContent.replace(/\s+/g, ' ').trim() || select.value);
          return `${this.dataset.consoleLabel} ${index + 1}: ${choices.join(' · ')}`;
        });
        const signature = JSON.stringify([quantity, price, consoles]);
        if (signature !== this.signature) {
          this.quantityOutput.textContent = quantity;
          this.priceOutput.textContent = price;
          this.consolesOutput.replaceChildren(...consoles.map(text => {
            const item = document.createElement('li');
            item.textContent = text;
            return item;
          }));
          this.signature = signature;
        }
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
